"use client";

import { environmentName } from "@/lib/environment";

/**
 * Displays a banner showing the current environment (staging, feature branch, local, etc.)
 * Hidden in production.
 */
export function EnvironmentBanner() {
  const envName = environmentName(process.env.NEXT_PUBLIC_URL || "");

  if (!envName) {
    return null;
  }

  const isLocal = envName === "local";

  return (
    // On phones it sits bottom left, clear of the menu button and the page toolbars.
    <div className="pointer-events-none fixed top-0 right-0 left-0 z-50 flex justify-center max-md:top-auto max-md:bottom-0 max-md:justify-start">
      <div
        className={`pointer-events-auto rounded-b-md px-3 py-0.5 text-xs font-bold text-white max-md:rounded-tr-md max-md:rounded-b-none ${
          isLocal ? "bg-green-500" : "bg-amber-500"
        }`}
      >
        {envName}
      </div>
    </div>
  );
}
